import { Box, Container, Text, Link } from '@chakra-ui/react';
import { SeparatorHelper } from '../general/separator';
export const AboutPage = () => {
  return (
    <Container maxW="3xl" bg="#e7e0e1" pb={10}>
      <Box mb={6} id="philosophy">
        <Text
          fontSize={{ base: '2xl', sm: '2xl', md: '2xl', lg: '3xl' }}
          pt={{ base: 4, md: 7 }}
          textAlign="center"
          fontFamily="'Bad Script', cursive"
        >
          About Fernsology
        </Text>
      </Box>

      {/* Intro Paragraph */}
      <Box textAlign="left" mb={4}>
        <Text opacity={0.95} lineHeight="1.6">
          Hi, my name is Funmi, and I’m the creator of Fernsology. I first
          thought about this concept in 2024, but I wasn’t fully committed or
          sure what direction to take. Then, something happened in the tenth
          month of 2025 that completely shifted my perspective. I realized I had
          to finally start this.
        </Text>
      </Box>

      {/* Backstory Section */}
      <Box textAlign="left" pt={4} mb={2}>
        <Text fontSize="xl" opacity={0.95} lineHeight="1.6">
          A little backstory:
        </Text>
      </Box>

      <SeparatorHelper />

      <Box textAlign="left" mb={4}>
        <Text opacity={0.95} lineHeight="1.6">
          I began writing technical articles back in 2020. I’ve always been a
          writer, even before tech entered the picture. I still remember winning
          my university’s talent show with poetry and how much I loved crafting
          words. Words as the intersection of knowledge and the ability to
          inform. So, I figured: why not blend my love for writing with my world
          in tech? My first ever article was “Mini Contact Cards – Using Algolia
          as the Search Service and Setting the Web App Up as a PWA.”
          <br />I remember when I wanted to mainly start writing on Medium, but
          friends encouraged me to use Hashnode instead, because of no paywalls,
          just pure sharing. Later, I moved from Nigeria to Canada for my
          master’s degree, and writing on my blog had to take a backseat for a
          while. But I never really stopped writing, just in a different form.
          My program exposed me to research, methodology, and how to think,
          find, and inform with structure. It was transformative. I knew that
          one day, I’d channel everything I had learned into something
          meaningful. Fernsology is that “something.”
        </Text>
      </Box>

      {/* Why the name */}
      <Box textAlign="left" pt={4} mb={2}>
        <Text fontSize="xl" opacity={0.95} lineHeight="1.6">
          Why the name “Fernsology”?
        </Text>
      </Box>

      <SeparatorHelper />

      <Box textAlign="left" mb={6}>
        <Text opacity={0.95} lineHeight="1.6">
          My first blog was simply called{' '}
          <Link
            href="https://ferns.hashnode.dev/"
            textDecoration="underline"
            textDecorationColor="#A67C52"
            target="_blank"
          >
            Ferns
          </Link>
          . When I decided to start again, I added “Sology” to symbolize more of
          study or quality I guess, or maybe I just really liked the name.
        </Text>
      </Box>
    </Container>
  );
};
